/**
 * Contact Form Modal
 * Handles the event reservation contact form modal
 */

class ContactFormModal {
  constructor() {
    this.modal = document.querySelector('[data-contact-modal]');
    this.overlay = this.modal?.querySelector('[data-contact-modal-overlay]');
    this.closeBtn = this.modal?.querySelector('[data-contact-modal-close]');
    this.form = this.modal?.querySelector('[data-contact-form]');
    this.eventTitleElement = this.modal?.querySelector('[data-event-title]');
    this.eventDatesContainer = this.modal?.querySelector('[data-event-dates-container]');
    this.successMessage = this.modal?.querySelector('[data-success-message]');
    this.errorMessage = this.modal?.querySelector('[data-error-message]');
    this.submitButton = this.modal?.querySelector('[data-submit-button]');
    this.currentEventTitle = '';

    if (!this.modal) return;

    this.init();
  }

  init() {
    // Listen for trigger button clicks
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-contact-modal-trigger]');
      if (trigger) {
        e.preventDefault();
        const productTitle = trigger.dataset.productTitle;
        const eventDatesHtml = trigger.dataset.eventDatesHtml;
        this.open(productTitle, eventDatesHtml);
      }
    });

    // Close button
    this.closeBtn?.addEventListener('click', () => this.close());

    // Overlay click to close
    this.overlay?.addEventListener('click', () => this.close());

    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-open')) {
        this.close();
      }
    });

    // Form submission
    this.form?.addEventListener('submit', (e) => this.handleSubmit(e));
  }

  open(productTitle = '', eventDatesHtml = '') {
    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    // Store event title for form submission
    this.currentEventTitle = productTitle;

    // Set event title
    if (this.eventTitleElement && productTitle) {
      this.eventTitleElement.textContent = productTitle;
    }

    // Set event dates
    if (this.eventDatesContainer) {
      if (eventDatesHtml && eventDatesHtml.trim()) {
        // Decode HTML entities
        const textarea = document.createElement('textarea');
        textarea.innerHTML = eventDatesHtml;
        const decodedHtml = textarea.value;

        this.eventDatesContainer.innerHTML = decodedHtml;
        this.eventDatesContainer.style.display = 'flex';
      } else {
        this.eventDatesContainer.innerHTML = '';
        this.eventDatesContainer.style.display = 'none';
      }
    }

    // Reset form and messages
    this.form?.reset();
    this.hideMessages();
  }

  close() {
    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  hideMessages() {
    if (this.successMessage) {
      this.successMessage.style.display = 'none';
    }
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
      this.errorMessage.textContent = '';
    }
  }

  showSuccess() {
    if (this.successMessage) {
      this.successMessage.style.display = 'block';
    }
    // Auto close after 3 seconds
    setTimeout(() => {
      this.close();
      // Reset after closing
      setTimeout(() => {
        this.hideMessages();
        this.form?.reset();
      }, 300);
    }, 3000);
  }

  showError(message) {
    if (this.errorMessage) {
      this.errorMessage.textContent = message;
      this.errorMessage.style.display = 'block';
    }
  }

  async handleSubmit(e) {
    e.preventDefault();

    // Get form field values
    const firstName = this.form.querySelector('[data-first-name]').value;
    const lastName = this.form.querySelector('[data-last-name]').value;
    const email = this.form.querySelector('input[name="contact[email]"]').value;
    const phone = this.form.querySelector('[data-phone]').value;
    const numberOfPeople = this.form.querySelector('[data-number-of-people]').value;
    const message = this.form.querySelector('[data-message]').value;
    const eventTitle = this.currentEventTitle;

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      this.showError('Please enter a valid email address.');
      return;
    }

    this.hideMessages();

    // Combine data into Shopify-compatible fields
    const fullName = `${firstName} ${lastName}`;
    const fullMessage = `Event: ${eventTitle}\n\nPhone: ${phone}\nNumber of people: ${numberOfPeople}\n\nMessage:\n${message}`;

    // Set hidden field values
    this.form.querySelector('[data-full-name]').value = fullName;
    this.form.querySelector('[data-full-message]').value = fullMessage;

    // Disable submit button during submission
    const originalButtonHTML = this.submitButton.innerHTML;
    this.submitButton.disabled = true;
    this.submitButton.innerHTML = '...';

    // Create FormData from the form (will include hidden fields)
    const formData = new FormData(this.form);

    // Submit the form using fetch without following redirects
    fetch(this.form.action, {
      method: 'POST',
      body: formData,
      redirect: 'manual'
    }).then(response => {
      // Any response (including opaqueredirect) means the form was submitted
      // Shopify contact forms always redirect on success, so we treat any response as success
      this.showSuccess();
    }).catch(error => {
      // Even errors might indicate successful submission with redirect
      console.log('Submission completed:', error);
      this.showSuccess();
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ContactFormModal();
  });
} else {
  new ContactFormModal();
}
